import { GAINSIGHT_PX_FUNCTION_NAME } from 'constants/AppConstants';

// Gainsight PX Tag
/* eslint-disable */
(function (n, t, a, e, co) {
  const i = GAINSIGHT_PX_FUNCTION_NAME; n[i] = n[i] || function () {
    (n[i].q = n[i].q || []).push(arguments);
  }, n[i].p = e; n[i].c = co;
  const r = t.createElement('script'); r.async = !0, r.src = `${a}?a=${e}`;
  const c = t.getElementsByTagName('script')[0]; c.parentNode.insertBefore(r, c);
}(window, document, 'https://web-sdk.aptrinsic.com/api/aptrinsic.js', process.env.REACT_APP_GAINSIGHT_PX_TAG_KEY));

/* eslint-enable */
// Gainsight PX Tag
